// extracted by mini-css-extract-plugin
module.exports = {"root":"Content_root__1PDOO","wrapper":"Content_wrapper__2P4B5"};